// FilterSheetModal.tsx
import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel, IonRow, IonCol, IonFooter, IonRange, IonSelect, IonSelectOption,
} from '@ionic/react';
import useStore from "../zustand/useStore";
import {actionToGetJobPostingByFilter} from "../apiHelpers/CommonAction";
import {_getDepartmentsList, _getIndianStates, _getWorkTypes} from "../apiHelpers/CommonHelper";

export default function FilterSheetModal({ isOpen, onDidDismiss,myJobPostsData,filterTypeSelection,selectedJobListUserType = 1,setFilterTypeSelection }) {
    const {
        selectedWorkTypes, setSelectedWorkTypes, selectedDepartments, setSelectedDepartments,
        setSelectedIsMyJobProfile,selectedIsMyJobProfile,
        selectedState, setSelectedState,experience, setExperience,salaryRange, setSalaryRange,
        resetFilters
    }= useStore();

    const handleWorkTypeCheckboxChange = (value) => {
        let newWorkTypes;
        if (selectedWorkTypes.includes(value)) {
            newWorkTypes = selectedWorkTypes.filter((v) => v !== value);
        } else {
            newWorkTypes = [...selectedWorkTypes, value];
        }

        setSelectedWorkTypes(newWorkTypes);
        handleApplyFilters(newWorkTypes, selectedDepartments, selectedState, experience, salaryRange,selectedIsMyJobProfile);
    };

    const handledDepartmentCheckboxChange = (value) => {
        let newDepartments;
        if (selectedDepartments.includes(value)) {
            newDepartments = selectedDepartments.filter((v) => v !== value);
        } else {
            newDepartments = [...selectedDepartments, value];
        }

        setSelectedDepartments(newDepartments);
        handleApplyFilters(selectedWorkTypes, newDepartments, selectedState, experience, salaryRange,selectedIsMyJobProfile);
    };

    const handleApplyFilters = async (workType,department,location,experience,salary) => {
        const payload = {};
        if (workType.length > 0) payload.work_type = workType;
        if (department.length > 0) payload.department = department;
        if (location.length > 0) payload.location = location;
        if (experience > 0) payload.experience = experience;
        if (salary > 0) payload.salary = salary;
        payload.me_mode = !!myJobPostsData;
        payload.user_type = selectedJobListUserType;
        await actionToGetJobPostingByFilter(true,payload);
    };

    const handleClearFilters = async () => {
        resetFilters();
        onDidDismiss();
        await actionToGetJobPostingByFilter(true, {
            user_type:selectedJobListUserType,
            me_mode:!!myJobPostsData
        });
    };

    const showApplyButton =
        selectedWorkTypes.length > 0 ||
        selectedDepartments.length > 0 ||
        selectedState.length > 0 ||
        experience > 0 ||
        selectedIsMyJobProfile ||
        salaryRange > 0;

    const handleExperienceChange = (e) => {
        setExperience(Number(e.detail.value));
        handleApplyFilters(selectedWorkTypes,selectedDepartments,selectedState,Number(e.detail.value),salaryRange,selectedIsMyJobProfile);
    };

    const handleStateChange = (e) => {
        setSelectedState(e.detail.value);
        handleApplyFilters(selectedWorkTypes,selectedDepartments,e.detail.value,experience,salaryRange,selectedIsMyJobProfile);
    };

    const handleSalaryChange = (e) => {
        setSalaryRange(Number(e.detail.value));
        handleApplyFilters(selectedWorkTypes,selectedDepartments,selectedState,experience,Number(e.detail.value),selectedIsMyJobProfile);
    };

    const handleSetMyJobProfileChange = () => {
        const isMyJobProfile = !selectedIsMyJobProfile
        setSelectedIsMyJobProfile(isMyJobProfile);
        handleApplyFilters(selectedWorkTypes,selectedDepartments,selectedState,experience,salaryRange,isMyJobProfile);
    };
    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="filter_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle className="filter_sheet_header_text">Filter jobs</IonTitle>
                    {(showApplyButton) && (
                        <IonButtons slot="end">
                            <div onClick={handleClearFilters} className="filter_sheet_clear_all_btn">Clear all</div>
                        </IonButtons>
                    )}
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <div className="filter-content">
                    <div className="filter-menu">
                        <IonList>
                            {[
                                "Work mode",
                                "Experience",
                                "Location",
                                "Salary",
                                "Department"
                            ].map((item, i) => (
                                <IonItem className={`filter_item_sheet_panel ${filterTypeSelection === item ? 'active' : ''}`} onClick={()=>setFilterTypeSelection(item)} key={i} button lines="none">
                                    {item}
                                </IonItem>
                            ))}
                        </IonList>
                    </div>

                    <div className="filter-options in_mobile_filter">
                        {/*{(filterTypeSelection === 'Me Mode') &&*/}
                        {/*    (<IonList>*/}
                        {/*        <IonItem lines="none" className={"filter_item_sheet_panel"}>*/}
                        {/*            <IonCheckbox*/}
                        {/*                slot="start"*/}
                        {/*                checked={selectedIsMyJobProfile}*/}
                        {/*                onIonChange={() =>*/}
                        {/*                    handleSetMyJobProfileChange()*/}
                        {/*                }*/}
                        {/*            />*/}
                        {/*            <IonLabel>Me Mode</IonLabel>*/}
                        {/*        </IonItem>*/}
                        {/*    </IonList>)*/}
                        {/*}*/}
                        {(filterTypeSelection === 'Work mode') &&
                            (<IonList>
                                {_getWorkTypes.map((type) => (
                                    <IonItem lines="none" className={"filter_item_sheet_panel"} key={type}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedWorkTypes.includes(type)}
                                            onIonChange={() =>
                                                handleWorkTypeCheckboxChange(type, selectedWorkTypes, setSelectedWorkTypes)
                                            }
                                        />
                                        <IonLabel>{type}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>)
                        }
                        {(filterTypeSelection === 'Experience') &&
                            (<IonList className={"in_mobile_filter_list"}>
                                <IonRange
                                    min={0}
                                    max={20}
                                    pin
                                    step={1}
                                    value={experience}
                                    onIonChange={handleExperienceChange}
                                />
                                <div className="range-labels" style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <span>{experience} Yrs</span>
                                    <span>{experience === 0 ? 'Any' : ''}</span>
                                </div>
                            </IonList>)
                        }
                        {(filterTypeSelection === 'Location') &&
                            (<IonList>
                                <IonLabel>Location</IonLabel>
                                <IonItem lines="none" className={"filter_item_sheet_panel"}>
                                    <IonSelect
                                        multiple={true}
                                        placeholder="Select Location"
                                        value={selectedState}
                                        onIonChange={handleStateChange}
                                    >
                                        {_getIndianStates.map((state, index) => (
                                            <IonSelectOption key={index} value={state}>
                                                {state}
                                            </IonSelectOption>
                                        ))}
                                    </IonSelect>
                                </IonItem>
                            </IonList>)
                        }
                        {(filterTypeSelection === 'Salary') &&
                            (<IonList className={"in_mobile_filter_list"}>
                                <IonRange
                                    min={0}
                                    max={30}
                                    step={1}
                                    pin
                                    value={salaryRange}
                                    onIonChange={handleSalaryChange}
                                />
                                <div className="range-labels" style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <span>{salaryRange.lower} LPA</span>
                                    <span>30+ LPA</span>
                                </div>
                            </IonList>)
                        }
                        {(filterTypeSelection === 'Department') &&
                            (<IonList>
                                {_getDepartmentsList.map((dept) => (
                                    <IonItem lines="none" key={dept} className={"filter_item_sheet_panel"}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedDepartments.includes(dept)}
                                            onIonChange={() =>
                                                handledDepartmentCheckboxChange(dept, selectedDepartments, setSelectedDepartments)
                                            }
                                        />
                                        <IonLabel>{dept}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>)
                        }
                    </div>
                </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={onDidDismiss}>Close</IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
